type Message = {
  role: 'user' | 'assistant';
  content: string;
};
type ChatData = {
  id: string;
  created_at: string;
  title: string;
  messages: Message[];
};
export const fetchKaiConfig = async (appId: string, netId: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/get_by_app_id`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ "app_id":appId }),
    });
    return await response.json();
};
export const authorize = async (appId: string, netId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/authorize`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ net_id: netId,"app_id":appId }),
  });
  return await response.json();
};
export const loadVirtualAssiatant = async (appId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/load_virtual_assistant`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ net_id: 'test',"app_id":appId }),
  });
  return await response.json();
};

export const fetchChatmessages  = async (appId: string, netId: string, chatid: string ) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/${chatid}/messages`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chat_id:chatid }),
  });
  return await response.json();
}

export const updateChatTitle  = async (appId: string, netId: string, chatid: string, title: string ) => {
  const data = { chat_id: chatid, new_title: title };
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/rename_title`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return await response.json();
}

export const deleteChat  = async (appId: string, netId: string, chatid: string ) => {
  
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/delete_chat_history/${chatid}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chat_id:chatid }),
  });
  return await response.json();
}
export const fetchChatHistory  = async (appId: string, netId: string ) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/get_chat_history`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ net_id: netId,"app_id":appId }),
  });
  return await response.json();
  return [
    {
      id: '1',
      date: '2025-02-12 15:30:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Which of the following is a core course offered in the Kellogg MBA curriculum?' },
        { role: 'assistant', content: ' Digital Marketing Strategy, Advanced Statistical Methods' },
      ],
    },
    {
      id: '2',
      date: '2025-02-11 13:40:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'What is the weather like?' },
        { role: 'assistant', content: 'It is sunny today.' }
      ]
    },
    {
      id: '3',
      date: '2025-02-12 16:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    },
    {
      id: '4',
      date: '2025-02-11 16:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    },
    {
      id: '5',
      date: '2025-02-10 16:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    },
    {
      id: '6',
      date: '2025-02-10 15:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    },
    {
      id: '7',
      date: '2025-02-10 15:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    },
    {
      id: '8',
      date: '2025-02-13 10:20:00',
      title: 'xyz',
      messages: [
        { role: 'user', content: 'Sample questions here' },
        { role: 'assistant', content: 'Test Answer' }
      ]
    }
  ];;
  // return await response.json();
};

export const fetchBotResponse = async (appId: string, netId: string, question: string, chatId: string | null, displayMessage?: string, fileAttachments?: Array<{name: string; isIndexed?: boolean; chunkCount?: number; fileId?: string; blobUrl?: string; fileType?: string}> ) => {
  if(chatId == 'chat'){
    chatId = null;
  }
  let username = localStorage.getItem('username') ? localStorage.getItem('username'): ""
  const body: any = { net_id: netId, app_id: appId, question: question, chat_id: chatId, user_name: username };
  if (displayMessage !== undefined) {
    body.display_message = displayMessage;
  }
  if (fileAttachments && fileAttachments.length > 0) {
    body.file_attachments = fileAttachments;
  }
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/ask_question`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const result = await response.json();
  return { data: result };
};

export const fetchBotResponseStream = async (appId: string, netId: string, question: string, chatId: string | null, displayMessage?: string, fileAttachments?: Array<{name: string; isIndexed?: boolean; chunkCount?: number; fileId?: string; blobUrl?: string; fileType?: string}>) => {
  if (chatId === 'chat') {
    chatId = null;
  }
  let username = localStorage.getItem('username') ? localStorage.getItem('username'): ""
  const body: any = {
    net_id: netId,
    app_id: appId,
    question: question,
    chat_id: chatId,
    user_name: username
  };
  if (displayMessage !== undefined) {
    body.display_message = displayMessage;
  }
  if (fileAttachments && fileAttachments.length > 0) {
    body.file_attachments = fileAttachments;
  }
  // Create a fetch request to the streaming endpoint
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/ask_question_streaming_tokens`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  // Return the response object for streaming
  return response;
};

export const fetchActiveFiles = async (chatId: string): Promise<Array<{file_id: string; file_name: string; chunk_count: number}>> => {
  if (!chatId || chatId === 'chat') return [];
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/active_files/${chatId}`, {
    credentials: 'include',
  });
  if (!response.ok) return [];
  const data = await response.json();
  return data.active_files || [];
};

// Create a mock response for `fetchKaiConfig`
// Function to simulate fetching Kai config data (mock response with conditions)
export const fetchKaiConfigStud = async (appId: string, netId: string) => {  
  // Simulate an invalid app ID scenario
  if (appId !== "5cf53127-c224-4731-bab0-0e4464636b15") {
    return {
      data: null,
      error: "Invalid app ID",
      authorised: false,
      message: "The provided app ID is invalid.",
      has_error: true,
    };
  }

  // Mock config data for valid appId
  const app_data = {
    id: "5cf53127-c224-4731-bab0-0e4464636b15",
    app_id: "5cf53127-c224-4731-bab0-0e4464636b15",
    app_name: "Suneetha Test2",
    app_description: "fff",
    app_owner: "pbt9636",
    app_publishstatus: "UNPUBLISHED",
    last_modified: "2025-01-31T08:11:07.108766",
    app_url: "",
    app_embedcode: "",
    app_ui_settings: {
      ui_backgroundcolor: "#FFFFFF",
      ui_fontcolor: "#BF4DE4",
      ui_headercolor: "#908DD1",
      ui_iconcolor: "#5E5E5E",
      ui_logo: "data:image/png;base64,...",
      ui_showheader: "true",
    },
    app_ai_settings: {
      ai_face: "https://ksmkaidevsa.blob.core.windows.net/kaiconfig/aiicon.png",
      ai_showgreeting: "true",
      ai_greeting: "Hi! I'm Kai. I'm your virtual Teaching Assistant for this class.",
      ai_name: "Suneetha Test2",
      ai_showsuggestedprompts: "true",
      ai_suggestedprompt1: "Tell me what I missed in the last class",
      ai_suggestedprompt2: "What's coming up in the next class?",
      ai_suggestedprompt3: "I'm curious about the student groups",
      ai_suggestedprompt4: "What's on the syllabus for this course?",
    },
    app_chat_settings: {
      chat_frequencypenalty: "-2",
      chat_maxlength: "128000",
      chat_model: "GPT-4o",
      chat_presencepenalty: "-2",
      chat_prompt: "",
      chat_promptinjection: "",
      chat_stopsequence: "",
      chat_temperature: "0",
      chat_topP: "0",
      chat_userag: "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.85 Safari/537.36 QIHU 360SEi18n",
    },
    is_authentication_enabled: "true",
    canvas_user_enabled: "true",
    local_user_enabled: "true",
    social_login_enabled: "true",
    canvas_users_excluded: [],
    local_users_included: [],
    selected_social_logins: [],
    knowledge_data: {
      canvas_course: [],
      data_uploaded_files: [],
      panopto: [],
      public_websites: [],
    },
  };

  // Simulate authorization check based on `netId`
  if (netId === "authorized_user") {
    return {
      data: app_data,
      error: null,
      authorised: true,
      message: "Access granted.",
      has_error: false,
    };
  } else {
    return {
      data: null,
      error: "Unauthorized access",
      authorised: false,
      message: "You are not authorized to access this app.",
      has_error: true,
    };
  }
};

export const decryptBypasstoken = async (bypasstoken: string, enKey: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/decryptBypassToken`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      encrypted_data:bypasstoken ,
      code: enKey
    })
  });

  return await response.json();
};
export const fetchChunkReference = async (chatId: string | null ) => {
  if(chatId == 'chat'){
    chatId = null;
  }
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/get_chat_references`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chat_id: chatId}),
  });
  const result = await response.json();
  return { data: result };
};
export const fetchChunkReferenceStud = async (chatId: string | null ) => {
  if(chatId == 'chat'){
    chatId = null;
  }
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/get_chat_references`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chat_id: chatId}),
    
  });
  const result = await response.json();
  return { data: result };
};
export const fetchInputMsgCount = async (net_id: string , app_id: string ) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/user_input_message_count`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ net_id: net_id, app_id: app_id}),
    
  });
  const result = await response.json();
  return result?.user_input_message_count;
};

export const fetchSysConfig  = async () => {

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/get_sys_config`, {
        credentials: 'include'
  });
  // console.log(response);
  return response.json();
}

export interface UploadAndExtractResponse {
  success: boolean;
  file_name: string;
  summary: string;
  char_count: number;
  file_id?: string;
  chunk_count?: number;
  is_indexed?: boolean;
  blob_url?: string;
  file_type?: string;
}

export const uploadAndExtractFile = async (file: File, userId: string, appId: string, chatId?: string): Promise<UploadAndExtractResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('user_id', userId);
  formData.append('app_id', appId);
  if (chatId && chatId !== 'chat') {
    formData.append('chat_id', chatId);
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/upload_and_extract`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    let message = 'Failed to upload file';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  return await response.json();
}

export const deleteUploadedFile = async (fileId: string, chunkCount: number, userId: string, appId: string, chatId?: string): Promise<{ success: boolean }> => {
  const formData = new FormData();
  formData.append('file_id', fileId);
  formData.append('chunk_count', chunkCount.toString());
  formData.append('user_id', userId);
  formData.append('app_id', appId);
  if (chatId && chatId !== 'chat') {
    formData.append('chat_id', chatId);
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/delete_uploaded_file`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    let message = 'Failed to delete uploaded file';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  return await response.json();
}

export const updateUploadedFilesChatId = async (fileIds: string[], chunkCounts: number[], newChatId: string): Promise<{ success: boolean }> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/update_uploaded_files_chat_id`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      file_ids: fileIds,
      chunk_counts: chunkCounts,
      new_chat_id: newChatId
    }),
  });

  if (!response.ok) {
    let message = 'Failed to update file chat IDs';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  return await response.json();
}

export const generateDownloadUrl = async (blobUrl: string): Promise<string> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/generate_download_url`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ blob_url: blobUrl }),
  });

  if (!response.ok) {
    let message = 'Failed to generate download URL';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  const data = await response.json();
  return data.download_url;
}

export const speechToText = async (audioBlob: Blob, userId: string, appId: string) => {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'audio.wav');
  formData.append('user_id', userId);
  formData.append('app_id', appId);

  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/speech_to_text`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    let message = 'Failed to transcribe audio';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  return await response.json();
}

export const textToSpeech = async (text: string, userId: string, appId: string, voiceName: string = "en-US-JennyNeural"): Promise<ArrayBuffer> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-assistant/text_to_speech`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      text,
      voice_name: voiceName,
      user_id: userId,
      app_id: appId
    }),
  });

  if (!response.ok) {
    let message = 'Failed to convert text to speech';
    try { const err = await response.json(); message = err.detail || message; } catch {}
    throw new Error(message);
  }

  return await response.arrayBuffer();
}

